module.exports = __webpack_public_path__ + "img/gjng2920_2.3a758360.svg";